import { FunctionComponent } from 'react'
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@black-bear-energy/rucksack'
import {
  SiteRFPDetails,
  SiteRFPMilestoneTypeAPIResponse,
} from '@black-bear-energy/black-bear-energy-common'
import { MilestoneRow } from 'components/Sites/MilestoneRow'
import houseSearch from '../../assets/house-search.svg'

export const MilestonesCard: FunctionComponent<MilestonesCardProps> = ({
  milestones = [],
  isFetching,
}) => {
  return (
    <Card sx={{ flex: '2 0 0' }}>
      <CardContent>
        <Typography variant="h6">Milestones</Typography>
        <TableContainer>
          <Table sx={{ '& .MuiTableCell-root': { padding: '8px 16px' } }}>
            <TableHead>
              <TableRow sx={{ '& .MuiTableCell-root': { fontSize: '14px' } }}>
                <TableCell key="milestone" sx={{ width: '33%' }}>
                  Milestone
                </TableCell>
                <TableCell key="status" sx={{ width: '33%' }}>
                  Status
                </TableCell>
                <TableCell key="date" sx={{ width: '33%' }}>
                  Date
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isFetching &&
                new Array(Object.values(SiteRFPMilestoneTypeAPIResponse).length)
                  .fill(0)
                  .map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {new Array(3).fill(0).map((cell, cellIndex) => (
                        <TableCell
                          key={cellIndex}
                          sx={{ display: 'table-cell' }}
                        >
                          <Skeleton
                            sx={{ height: '17px', transform: 'none' }}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              {!isFetching && milestones.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} sx={{ border: 0 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2.5,
                        py: 5,
                      }}
                    >
                      <img
                        src={houseSearch}
                        alt=""
                        style={{ width: '200px', height: 'auto' }}
                      />
                      <Typography variant="body1" sx={{ textAlign: 'center' }}>
                        There are no milestones for this site.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {!isFetching &&
                milestones.map((milestone) => (
                  <MilestoneRow milestone={milestone} key={milestone.type} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}

export interface MilestonesCardProps {
  milestones?: SiteRFPDetails['milestones']
  isFetching: boolean
}
